<script lang="ts">
  // English / हिन्दी / தமிழ் switch (a radio group, so it reads correctly to screen readers).
  import { lang, LANGS, t } from '../lib/i18n';
  let { compact = false }: { compact?: boolean } = $props();
</script>

<div class="lang" role="radiogroup" aria-label={$t('lang.label')}>
  {#each LANGS as l (l.id)}
    <button role="radio" aria-checked={$lang === l.id} class:on={$lang === l.id} lang={l.id} title={l.label} onclick={() => lang.set(l.id)}>
      {compact ? l.short : l.label}
    </button>
  {/each}
</div>

<style>
  .lang { display: inline-flex; gap: 2px; padding: 2px; border-radius: var(--radius-pill); border: 1px solid var(--line); background: var(--surface-2); }
  .lang button { padding: 3px 10px; border-radius: var(--radius-pill); font-size: var(--fs-2xs); font-weight: 700; color: var(--text-3); line-height: 1.4; }
  .lang button:hover { color: var(--text); }
  .lang button.on { color: var(--accent); background: var(--accent-soft); }
  .lang button:focus-visible { outline: 2px solid var(--accent); outline-offset: 1px; }
</style>
